import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import '../../../app.css'
import dayjs from 'dayjs';

export default function DatePickerComponent({ formData, onChange, fieldId, width, height, value, disableFuture = false }) {
    let style = { height: "40px", width }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disableFuture={disableFuture}
                className={height ? 'heigth' : ""}
                onChange={(e) => { onChange(fieldId, e?.$d) }}
                value={
                    formData?.[fieldId]
                        ? dayjs(formData?.[fieldId])
                        : value ? dayjs(value) : null
                }
                renderInput={(params) => <TextField style={style} {...params} />}
            />
        </LocalizationProvider>
    )
}